import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { c as o, a as i } from "../../../index-CROKJrb5.js";
import { c as m, f as u } from "../../../create-component-CBAeEoQ6.js";
import { Image as f } from "../../Image/index.js";
const n = o({
  base: "cur-absolute cur-top-0 cur-left-0 cur-right-0 cur-flex cur-flex-wrap cur-gap-1",
  variants: {
    labelAlign: {
      left: null,
      right: "cur-justify-end"
    }
  }
}), h = m(
  "CardImage",
  u(
    ({ children: e, className: s, label: r, labelAlign: t = "left", ...c }, l) => /* @__PURE__ */ a.jsxs(
      f,
      {
        ref: l,
        className: i("cur-relative cur-shrink-0", s),
        ...c,
        children: [
          r ? /* @__PURE__ */ a.jsx("div", { className: n({ labelAlign: t }), children: r }) : null,
          e
        ]
      }
    )
  )
);
export {
  h as CardImage
};
//# sourceMappingURL=index.js.map
